import { extend, override } from 'flarum/common/extend';
import ChangeEmailModal from 'flarum/forum/components/ChangeEmailModal';
import Button from 'flarum/common/components/Button';

override(ChangeEmailModal.prototype, 'content', function() {
  if (this.success) {
    return (
      <div className="Modal-body">
        <div className="Form Form--centered">
          <p className="helpText">
            {app.translator.trans('core.forum.change_email.confirmation_message', { email: <strong>{this.email()}</strong> })}
          </p>
          <div className="Form-group">
            <Button className="Button Button--primary Button--block" onclick={this.hide.bind(this)}>
              {app.translator.trans('core.forum.change_email.dismiss_button')}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="Modal-body">
      <div className="Form Form--centered">
        <div className="Form-group">
          <input
            type="email"
            name="email"
            className="FormControl"
            placeholder={app.session.user.email()}
            bidi={this.email}
            disabled={this.loading}
          />
        </div>
        <div className="Form-group">
          {Button.component(
            {
              className: 'Button Button--primary Button--block',
              type: 'submit',
              loading: this.loading,
            },
            app.translator.trans('core.forum.change_email.submit_button')
          )}
        </div>
      </div>
    </div>
  );
});
